import { useAuth } from '@frontend/features/auth/hooks/useAuth';
import { useQuery } from 'react-query';
import { useHotelAgency } from './HotelAgencyContext';
import { client } from '@frontend/features/common/services';

export interface HotelBookingPermission {
  connector_account_id: string;
  bookings_enabled: boolean;
  sales_agencies?: { id: number; name: string }[];
}
export function useHotelBookingPermissions(owner?: number) {
  const { myProfile } = useAuth();
  const context = useHotelAgency();
  const agency = owner ?? context;
  return useQuery(
    ['hotel-booking-permissions', agency, myProfile?.id],
    async () =>
      (
        await client.get<{ data: HotelBookingPermission[] }>('hotels/booking-permissions', {
          headers: { 'Resource-Agency-Id': String(agency) },
        })
      ).data.data,
    { enabled: !!myProfile?.id, retry: false, staleTime: 0, refetchOnMount: 'always' },
  );
}
export function accountCanBook(accounts: HotelBookingPermission[] | undefined, accountId: string | undefined) {
  return (
    !!accountId &&
    accounts?.some((account) => account.connector_account_id === accountId && account.bookings_enabled === true) ===
      true
  );
}
